/**
 * @file コンポーネント：フル動画ページタイムライン機器 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledList = styled.ul`
    margin-top: 8px;
`;

export const StyledListItem = styled.li`
    display: flex;
    margin-bottom: 8px;
    color: #ffffff;
    font-size: 11px;
    line-height: 16px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const StyledListItemIcon = styled.span`
    margin-right: 4px;
`;

export const StyledListItemText = styled.span``;
